<div class="hd-voice-page">
    <section class="video-section">
        <video class="video" id="hd-voice-video" poster="assets/img/HD voice shot.svg" [muted]="true" preload="auto" autoplay playsinline loop>
            <source src="assets/videos/1059845399-sd.mp4" type="video/mp4">
            Video tag is not supported in this browser.
        </video>
        <div class="banner section-paddings">
            <div class="banner-text">
                <p class="note">HD CLEAR AUDIO</p>
                <h1 class="header">A New Dimension of Voice</h1>
                <p>Experience HD Voice crystal-clear audio and reduced background noise</p>
            </div>
        </div>
    </section>
    <section class="section-paddings">
        <div class="images-description-section">
            <div class="left-section">
                <picture>
                    <source srcset='assets/img/left-girl.webp' media="(min-width: 640px)" type="image/webp">
                    <source srcset='assets/img/left-girl.png' media="(min-width: 640px)" type="image/png">
                    <source srcset='assets/img/left-girl-mob.webp' media="(max-width: 639.9px)" type="image/webp">
                    <source srcset='assets/img/left-girl-mob.png' media="(max-width: 639.9px)" type="image/png">
                    <img src="assets/img/left-girl.png" alt="left-girl">
                </picture>
                <div>
                    <h3 class="title">Crisp Call Quality</h3>
                    <p class="desc">
                        Enjoy calls that sound like you’re having a conversation with someone in the same room instead
                        of across the country.
                    </p>
                </div>
            </div>
            <div class="right-section">
                <picture>
                    <source srcset='assets/img/right-girl.webp' media="(min-width: 640px)" type="image/webp">
                    <source srcset='assets/img/right-girl.png' media="(min-width: 640px)" type="image/png">
                    <source srcset='assets/img/right-girl-mob.webp' media="(max-width: 639.9px)" type="image/webp">
                    <source srcset='assets/img/right-girl-mob.png' media="(max-width: 639.9px)" type="image/png">
                    <img src="assets/img/right-girl.png" alt="right-girl">
                </picture>
                <div>
                    <h3 class="title">Less Background Noise</h3>
                    <p class="desc">
                        HD Voice uses wide-band audio technology and noise cancellation. That means voices sound more
                        natural and you’ll hear much less background noise compared to standard voice calls.
                        Conversations will sound more natural.
                    </p>
                </div>
            </div>
        </div>
    </section>
    <section class="hd-voice-description section-paddings">
        <div class="paragraph">
            <h2 class="title">Simultaneous voice and data at 4G LTE speeds</h2>
            <p class="desc">HD Voice uses our all-IP, 4G LTE network so you can have crystal clear conversations while
                surfing the Web at 4G LTE speeds. When HD Voice is enabled, your phone will have access to the latest
                Advanced Calling features, which are made possible by Voice over LTE (VoLTE)
            </p>
            <p class="border"></p>
            <p>To use FreeUP HD Voice, both caller and receiver need an HD Voice capable phone and must be
                located within HD Voice coverage areas. Not all carriers have interoperability with FreeUP HD Voice.
                *HD Voice is not available in all areas. HD Voice Requirements: To experience HD Voice, both parties on
                the call must be located in an HD Voice coverage area and have an HD Voice capable device and SIM with
                HD Voice set up on their account. Not all carriers have interoperability with FreeUP HD
                Voice. Incompatible Services or Features: HD Voice is available at no additional cost; standard voice
                rates apply and are charged according to your wireless rate plan.
            </p>
        </div>
    </section>
    <section class="faqs-section section-paddings">
        <h2 class="header">FAQs to help you get started</h2>
                    <div class=" questions">
                        <div *ngFor="let qst of firstFourQuestions">
                            <app-question-answer question="{{qst?.fields?.questionText}}" [id]="qst?.fields?.questionId"
                                [class.active]="qst?.fields?.questionId == questionId"
                                [isActive]="qst?.fields?.questionId == questionId"
                                (click)="toggleActive(qst?.fields?.questionId,qst?.fields?.answerId)">
                                <p (click)="collapsed=true" id="{{qst?.fields?.answerId}}"></p>
                            </app-question-answer>
                        </div>
                        <div *ngIf="!!showMore">
                            <div *ngFor="let qst of restQuestions">
                                <app-question-answer question="{{qst?.fields?.questionText}}"
                                    [id]="qst?.fields?.questionId"
                                    [class.active]="qst?.fields?.questionId == questionId"
                                    [isActive]="qst?.fields?.questionId == questionId"
                                    (click)="toggleActive(qst?.fields?.questionId,qst?.fields?.answerId)">
                                    <p (click)="collapsed=true" id="{{qst?.fields?.answerId}}"></p>
                                </app-question-answer>
                            </div>
                        </div>
                        <div class="border"></div>
                    </div>
        <p class="more-or-less-faqs" *ngIf="!showMore"><a (click)="showMore = true">More FAQs</a></p>
        <p class="more-or-less-faqs" *ngIf="!!showMore"><a (click)="showMore = false; questionId = 'q0'">Less FAQs</a>
        </p>
        <div class="info">
            <p class="description1">Most unlocked GSM phones will work on the FreeUp network, however, we don’t have
                control over the availability of the features we provide that are not available from your unlocked
                phone. Unfortunately, some features like Wi-Fi calling, VoLTE, MMS may not work on our network. FreeUP
                Mobile cannot and does not guarantee the functionality or performance of any handsets or devices for use
                on the FreeUP Mobile network. Nor do we guarantee the functionality of any handsets or devices. As a
                courtesy, we provide Internet and picture messaging (MMS) settings for some devices. FreeUP Mobile
                cannot guarantee the effectiveness of these settings, nor their placement in the device and therefore
                does not assume any liability for the lack of effectiveness of these settings for the devices.
            </p>
            <p class="description2">Wi-Fi Calling requires Wi-Fi Calling capable smartphone and Wi-Fi network. Once
                enabled, phone automatically makes/receives calls/text messages over Wi-Fi in the U.S. If wireless
                network coverage is weak or unavailable, or outside the Domestic Coverage Area anytime you connect to a
                Wi-Fi network. Wi-Fi Calling is available on select devices. Use of Wi-Fi Calling may be restricted in
                some countries. If you move in or out of Wi-Fi coverage while on a Wi-Fi call, your call will disconnect
                unless you have AT&T HD Voice coverage (911 calls will disconnect even if you are within HD Voice
                coverage). HD Voice not available everywhere. To enable Wi-Fi Calling, you must have a wireless account
                provisioned for HD Voice. Cannot use Wi-Fi Calling to call 211, 311, 511, and 811. <a
                    [routerLink]="[SUPPORT_ROUTE_URLS.BASE + '/'+SUPPORT_ROUTE_URLS.FAQS + '/wifi-calling']">Learn
                    more</a>.</p>
        </div>
    </section>
</div>